import { ClientDeviceType, ComponentType, GetPageComponentViewModel } from '@/types/cml-api'

export const TimerTextColor = '#db2777'

export const CountdownMock: GetPageComponentViewModel = {
    type: ComponentType.CountDown,
    deviceTypes: 'Mobile, Desktop' as ClientDeviceType,
    id: '2f12ef6d-7be1-4dfb-8d17-45f600e4f72c',
    title: 'تست',
    backgroundColor: '#DB2777',
    seeMoreLink: null,
    designType: undefined,
    desktopImageUrl: 'https://cdn.khanoumi.com/develop/cml/carousel-big/be/63/be63db23f0104699ac8e1ba76b82c7c2.jpeg',
    link: '/brands/schon',
    mobileImageUrl: 'https://cdn.khanoumi.com/stage/cml/carousel-big/e1/75/e175ec5deffb46ce89ece851941b2f53.jpeg',
    endTime: '2025-08-23T20:30:00+00:00',
    videoUrl: undefined,
    thumbnailImageUrl: undefined,
    text: undefined,
    buttonDesignType: undefined,
    items: [],
}
